'use strict';
var inputs = document.querySelectorAll('input');
inputs.forEach(function(input) {
    var label = document.createElement('label');
    label.classList.add('field-label');
    label.setAttribute('for', input.id);
    input.placeholder = input.name[0].toLocaleUpperCase() + input.name.slice(1);
    input.parentElement.append(label);
    label.textContent = input.name.toLocaleUpperCase();
});

//# sourceMappingURL=js_task_fix_form_DOM.0a57ca61.js.map
